import TagUi from "@UI/TagUi";
import TooltipUI from "@UI/TooltipUI";
import ButtonUI from "@UI/ButtonUI";

import { inject, observer } from "mobx-react";

import { Card } from "primereact/card";
import { InputNumber } from "primereact/inputnumber";
import { MultiSelect } from "primereact/multiselect";

import { useEffect, useState } from "react";

import CreateNode from "../../CreateNode";
import "./style.scss";
import { toJS } from "mobx";
import { useParams } from "react-router-dom";

const defaultVar = { data: {}, code: null, percent: 100 };

const AbVariants = inject("mainStore")(
    observer(({ mainStore, inputs, setStateData, setDataMulti, dataKey, type }) => {
        const data = mainStore.getMainStore("detailData");
        const { firstParam, secondParam } = useParams();

        const isDisabled = !data?.draft && secondParam !== "add";
        const [testFields, setTestFields] = useState([]);
        const [offer, setOffer] = useState(false);

        useEffect(() => {
            if (data?.offerId) {
                getOffer(data?.offerId);
            }
        }, [data.offerId]);

        useEffect(() => {
            if (data && data.abModsVariants && data.abModsVariants.length) {
                const dataWKeys = data.abModsVariants.find((f) => (f.data ? Object.keys(f.data).length : false))?.data;

                if (dataWKeys) {
                    setTestFields(
                        Object.keys(dataWKeys).reduce((acc, val) => {
                            const field = testFieldsOptions[type].find((f) => val == f.key);
                            if (field) {
                                acc.push(field);
                            }
                            return acc;
                        }, []),
                    );
                }
            }
        }, [data]);

        useEffect(() => {
            if (offer._id) {
                let keys = testFields.map((m) => m.key);
                if (data.abModsVariants) {
                    let newData = data.abModsVariants.map((f, fIndex) => {
                        let newData = fIndex == 0 ? offer : f.data ? f.data : {};
                        newData = Object.entries(newData).reduce((acc, [key, value]) => {
                            if (value && typeof value === "object") {
                                Object.entries(value).forEach(([fKey, fVal]) => {
                                    if (keys.includes(`${key}#${fKey}`)) {
                                        acc[`${key}.${fKey}`] = fVal;
                                    } else if (keys.includes(key)) {
                                        acc[key] = value;
                                    }
                                });
                            } else if (keys.includes(key)) {
                                if ((key === "cover" || key === "coverMobile") && fIndex === 0) {
                                    acc[key] = offer[key] ? offer[key] : offer?.vendor[logoMap[key]] || null;
                                } else {
                                    acc[key] = value;
                                }
                            }

                            return acc;
                        }, {});
                        return { ...f, data: newData };
                    });

                    setStateData(["abModsVariants"], newData);
                }
            }
        }, [offer._id]);

        const getOffer = async (id) => {
            const resp = await mainStore.getByUrl(`promo/offers/${id}`);
            if (resp && resp.success) {
                mainStore.setMainStore("defaultOffer", resp.data);
                setOffer(resp.data);
            }
        };

        const reqInputs =
            inputs && inputs.inputs
                ? Object.entries(inputs.inputs).reduce((acc, val) => {
                      const [key, value] = val;

                      if (value.required) {
                          acc.push(key);
                      }
                      return acc;
                  }, [])
                : [];

        const changeVariants = (item) => {
            const checkRequired = reqInputs.every((e) => data[e]);

            if (checkRequired) {
                let abModsVariants = data.abModsVariants || [];

                if (item) {
                    abModsVariants.splice(item.index, 1);
                } else {
                    if (!abModsVariants.length) abModsVariants.push(defaultVar);
                    abModsVariants.push(defaultVar);
                }
                const newArr = [];
                abModsVariants.forEach((row, idx, arr) => {
                    const item = { ...row };

                    if (arr.length === 3 && idx === 2) {
                        item.percent = 33.34;
                    } else {
                        item.percent = Number((100 / (arr.length || 1)).toFixed(2));
                    }

                    item.code = `${data.code}_v${idx + 1}`;
                    newArr.push(item);
                });

                setStateData(["abModsVariants"], newArr);
            } else {
                mainStore.setMainStore("toast", { severity: "error", life: 3000, summary: "Заполните обязательные поля" });
            }
        };

        const changeInputVariants = (e, variant) => {
            if (isDisabled) return;

            let variants = data.abModsVariants;
            variants.find((f) => f.code == variant.code).percent = e.target.value;
            setStateData(["abModsVariants"], variants);
        };

        const focusInputVariants = (e, variant) => {
            const inputs = document.querySelectorAll(".aboffers-variants");
            if (inputs && inputs.length) {
                inputs.forEach((f) => {
                    f.classList.remove("error");
                });
            }
        };

        const blurInputVariants = (e, variant) => {
            const percents = data.abModsVariants.reduce((acc, val) => {
                acc += val.percent;
                return acc;
            }, 0);
            if (percents !== 100) {
                const inputs = document.querySelectorAll(".aboffers-variants");
                if (inputs && inputs.length) {
                    inputs.forEach((f) => {
                        f.classList.add("error");
                    });
                }
                mainStore.setMainStore({ severity: "error", life: 3000, summary: "Сумма процентов должна быть равна 100%" });
            }
        };

        const addTestFields = (e) => {
            if (isDisabled) return;

            let variants = data.abModsVariants;
            let keys = e.value.map((m) => m.key);
            setTestFields(e.value);
            if (variants && variants.length) {
                if (offer) {
                    let newData = variants.map((f, fIndex) => {
                        let newData = fIndex == 0 ? offer : f.data ? f.data : {};

                        newData = Object.entries(newData).reduce((acc, val) => {
                            const [key, value] = val;

                            if (value && typeof value == "object") {
                                Object.entries(value).forEach((f) => {
                                    const [fKey, fVal] = f;
                                    if (keys.includes(`${key}#${fKey}`)) {
                                        acc[`${key}#${fKey}`] = fVal;
                                    } else if (keys.includes(key)) {
                                        acc[key] = value;
                                    }
                                });
                            } else if (keys.includes(key)) {
                                if ((key === "cover" || key === "coverMobile") && fIndex === 0) {
                                    acc[key] = offer[key] ? offer[key] : offer?.vendor[logoMap[key]] || null;
                                } else {
                                    acc[key] = value;
                                }
                            }

                            return acc;
                        }, {});
                        return { ...f, data: newData };
                    });

                    setStateData(["abModsVariants"], newData);
                } else {
                    variants.forEach((item) => {
                        for (let key in item.data) {
                            if (!keys.includes(key)) {
                                delete item.data[key];
                            }
                        }
                        keys.forEach((key) => {
                            if (!(key in item.data)) {
                                item.data[key] = null;
                            }
                        });
                    });

                    setStateData(["abModsVariants"], variants);
                }
            }
        };

        return (
            <>
                <Card className={`detail__list`} title={`Количество вариантов и распределение %`}>
                    <div className="aboffers-variants">
                        <ButtonUI type="button" icon="pi pi-plus" label="Добавить вариант" className="aboffers-variants__percents-button" onClick={() => changeVariants(false)} disabled={isDisabled} />
                        <div className="aboffers-variants__items">
                            {Array.isArray(data.abModsVariants)
                                ? data.abModsVariants.map((item, index) => {
                                      const val = item.percent;

                                      return (
                                          <div key={index} className={`detail__item`}>
                                              <label className={""} htmlFor={""}>
                                                  Вариант {variantName[index]}
                                              </label>
                                              <div style={{ position: "relative" }}>
                                                  {/* <InputText placeholder={'Введите процент'} value={val || ''} onChange={(e) => changeInputVariants(e, item)} className={''} /> */}
                                                  <InputNumber
                                                      className={`aboffers-variants__item `}
                                                      placeholder={"Введите процент"}
                                                      value={val || 0}
                                                      onValueChange={(e) => changeInputVariants(e, item)}
                                                      onFocus={focusInputVariants}
                                                      onBlur={blurInputVariants}
                                                      minFractionDigits={2}
                                                      maxFractionDigits={2}
                                                      disabled={isDisabled}
                                                  />
                                                  {data.abModsVariants.length > 1 && !isDisabled && <i className="pi pi-trash" onClick={() => changeVariants({ item, index })} />}
                                                  {/* {index > 1 && <i className="pi pi-trash" onClick={() => changeVariants(item)}/>} */}
                                              </div>
                                          </div>
                                      );
                                  })
                                : null}
                        </div>
                    </div>
                </Card>
                <Card className={`detail__list`} title={`Что тестируем`}>
                    <div className="aboffers-variants">
                        <div className={`detail__item`}>
                            <label className={""} htmlFor={""}>
                                Тестируемые поля
                            </label>
                            <MultiSelect
                                filter={true}
                                value={testFields || []}
                                options={testFieldsOptions[type]}
                                // optionValue={'key'}
                                optionLabel={"label"}
                                placeholder={"Выберите поле"}
                                showClear={true}
                                emptyFilterMessage={"Нет элементов для выбора"}
                                emptyMessage={"Нет элементов для выбора"}
                                disabled={isDisabled}
                                showSelectAll={false}
                                onChange={(e) => addTestFields(e)}
                                appendTo={"self"}
                                display="chip"
                            />
                        </div>
                    </div>
                </Card>
                {testFields && testFields.length
                    ? testFields.map((item, index) => {
                          return (
                              <Card key={index} className={`detail__list`} title={item.label}>
                                  {data.abModsVariants?.map((variant, variantIndex) => {
                                      let keys = item.key;
                                      let val = variant.data?.[keys] ? variant.data[keys] : "";

                                      return (
                                          <div key={variantIndex} className="aboffers-variants_item">
                                              <div className="aboffers-variants__variant-title">
                                                  <span>Вариант {variantName[variantIndex]}.</span>
                                                  <TagUi className={`tag-code-${index}-${variantIndex}`} value={`Код ${variant?.code || ""}`} bgColor="primary" />

                                                  <TooltipUI target={`.tag-code-${index}-${variantIndex}`} content={variant?.code} position="bottom" />
                                              </div>
                                              <div className="aboffers-variants__variant-inputs">
                                                  <CreateNode
                                                      key={variantIndex}
                                                      fullData={data}
                                                      keyTo={item.key}
                                                      item={item}
                                                      prePath={["abModsVariants", variantIndex, "data"]}
                                                      value={val}
                                                      setData={setStateData}
                                                      setDataMulti={setDataMulti}
                                                      disabled={isDisabled || (firstParam === "test-offer" && !variantIndex)}
                                                      urlUpload={dataKey}
                                                      changeableData={data}
                                                  />
                                              </div>
                                          </div>
                                      );
                                  })}
                              </Card>
                          );
                      })
                    : null}

                {type === "test-offer" && testFields && testFields.length ? (
                    <Card className={`detail__list`} title={`Превью А/Б`}>
                        {data.abModsVariants?.map((variant, variantIndex) => {
                            return (
                                <div key={variantIndex} className="aboffers-variants_item">
                                    <div className="aboffers-variants__variant-title">
                                        <span>Вариант {variantName[variantIndex]}.</span>
                                        <TagUi className={`tag-code-${variantIndex}`} value={`Код ${variant?.code || ""}`} bgColor="primary" />
                                        <TooltipUI target={`.tag-code-${variantIndex}`} content={variant?.code} position="bottom" />
                                    </div>
                                    <div className="aboffers-variants__variant-inputs">
                                        {preview.map((item, index) => {
                                            const val = variant.data ? variant.data : "";
                                            const newOffer = { ...offer, ...val };

                                            return (
                                                <CreateNode
                                                    key={index}
                                                    changeableData={newOffer}
                                                    keyTo={item.key}
                                                    item={item}
                                                    prePath={["abModsVariants", variantIndex, "data"]}
                                                    value={val}
                                                    setData={setStateData}
                                                    setDataMulti={setDataMulti}
                                                    disabled={isDisabled || !variantIndex}
                                                    urlUpload={dataKey}
                                                />
                                            );
                                        })}
                                    </div>
                                    <div className="aboffers-variants__variant-inputs flex">
                                        {previewModal.map((item, index) => {
                                            const val = variant.data ? variant.data : "";
                                            const newOffer = { ...offer, ...val };

                                            return (
                                                <CreateNode
                                                    key={index}
                                                    changeableData={newOffer}
                                                    keyTo={item.key}
                                                    item={item}
                                                    prePath={["abModsVariants", variantIndex, "data"]}
                                                    value={val}
                                                    setData={setStateData}
                                                    setDataMulti={setDataMulti}
                                                    disabled={isDisabled}
                                                    urlUpload={dataKey}
                                                />
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </Card>
                ) : null}
            </>
        );
    }),
);

const logoMap = {
    cover: "logoList",
    coverMobile: "squareLogo",
};

const preview = [
    {
        type: "previewItem",
        addClass: "full imageupload previewupload",
        label: "Desktop",
        pathStorage: "cover",
        noRemove: true,
    },
    {
        type: "previewItem",
        addClass: "full previewmobile",
        label: "Mobile",
        pathStorage: "coverMobile",
        noRemove: true,
    },
];

const previewModal = [
    {
        type: "preview",
        label: "Desktop",
        pathStorage: "cover",
    },
    {
        type: "defaultCard",
        previewType: "previewMobile",
        label: "Mobile",
        pathStorage: "coverMobile",
    },
];

const testFieldsOptions = {
    "test-site": [
        {
            key: "colorHeader",
            label: "Цвет шапки",
            type: "string",
        },
        {
            key: "fortuneOffline",
            label: "Показ колеса",
            type: "checkbox",
        },
        {
            key: "avaWheel",
            label: "Показ очереди",
            type: "checkbox",
        },
        {
            key: "metrikaKey",
            label: "Параметр для метрики",
            type: "string",
        },

        {
            key: "testOfferList",
            label: "Вариант отображения оффера",
            type: "string",
        },

        {
            key: "siteTheme",
            label: "Тема сайта",
            type: "string",
        },
    ],

    "test-offer": [
        {
            key: "title",
            label: "Название оффера",
            type: "htmlText",
            addClass: "short",
            header: () => (
                <span className="ql-formats">
                    <button className="ql-bold" />
                    <button className="ql-italic" />
                    <button className="ql-underline" />
                    <button className="ql-strike" />
                </span>
            ),
        },
        {
            key: "surveyId",
            label: "Квал вопросы",
            type: "questions",
        },
        {
            key: "description",
            label: "Пользовательское соглашение",
            type: "htmlText",
        },
        {
            key: "activationLink",
            label: "Ссылка на активацию ({{PROMOCODE}})",
            type: "string",
        },

        {
            key: "cover",
            label: "Логотип Desktop (280x87)",
            type: "image",
            required: true,
            pathStorage: "cover",
            addClass: "imageupload",
        },
        {
            key: "coverMobile",
            label: "Логотип Mobile (87х87)",
            type: "image",
            required: true,
            pathStorage: "coverMobile",
            addClass: "imageupload",
        },
        // {
        //     key: "sortNum",
        //     label: "Сортировка",
        //     type: "number",
        // },

        { key: "offerDetail#termsOfUse", label: "Условия акции", type: "htmlText", required: true, placeholder: "" },

        {
            key: "bucketCode",
            label: "Корзина с промиками (Работает только если основной оффер тащится из корзины)",
            type: "selectSuggest",
            filterBy: "title,_id",
            required: true,
            fetchOnClick: true,
            apiUrl: "/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1",
            dataKey: "promo_bickets_suggest",
            optionValue: "code",
            optionLabel: "title",
            placeholder: "Выберите корзину",
            appendTo: "self",
        },
        {
            key: "deviceTargetModel",
            label: "Таргетинг по типу устройства и ОС",
            type: "deviceTarget",
        },
    ],
};

const variantName = { 0: "А", 1: "Б", 2: "В", 3: "Г", 4: "Д", 5: "Е", 6: "Ж" };

export default AbVariants;
